import { blocks } from "./theme/blocks"
import { components } from "./theme/components"
import { palette } from "./theme/palette"
import { typography } from "./theme/typography"

export const UIParams = {
  blocks,
  palette,
  typography,
  components,
}
